export const dropdownContainer = `
  absolute right-0 top-full mt-3 w-80 sm:w-96 max-w-[92vw] z-50
  bg-slate-900/95 backdrop-blur-xl border border-slate-700/60
  rounded-2xl shadow-2xl overflow-hidden
  animate-in fade-in zoom-in-95 duration-200
`.trim();

export const header = `
  px-4 py-3 border-b border-slate-800/80 flex items-center justify-between
  bg-slate-900/80 backdrop-blur-md
`.trim();

export const headerTitle = `
  text-sm font-bold text-white flex items-center gap-2
`.trim();

export const unreadBadge = `
  px-2 py-0.5 text-xs font-semibold rounded-full
  bg-emerald-500/20 text-emerald-400 border border-emerald-500/30
`.trim();

export const markAllBtn = `
  text-xs text-slate-400 hover:text-emerald-400 font-medium transition-colors
  flex items-center gap-1.5 focus:outline-none disabled:opacity-40
`.trim();

export const tabContainer = `
  flex items-center gap-1 p-1 bg-slate-950/50 border-b border-slate-800/60
`.trim();

export const getTabClass = (isActive: boolean) => `
  flex-1 py-1.5 text-xs font-medium rounded-lg text-center transition-all cursor-pointer
  ${isActive 
    ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 shadow-sm font-semibold' 
    : 'text-slate-400 hover:text-slate-200 hover:bg-slate-800/40'}
`.trim();

export const listContainer = `
  max-h-80 overflow-y-auto divide-y divide-slate-800/50
  scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-slate-900
`.trim();

export const getItemClass = (isRead: boolean) => `
  p-3.5 flex items-start gap-3 transition-all cursor-pointer relative group
  ${isRead 
    ? 'bg-slate-900/40 hover:bg-slate-800/40 opacity-75' 
    : 'bg-slate-800/30 hover:bg-slate-800/60 border-l-2 border-emerald-500'}
`.trim();

export const itemTitle = `
  text-xs font-medium text-slate-200 leading-snug line-clamp-2
`.trim();

export const itemTime = `
  text-[10px] text-slate-400 font-mono mt-1 flex items-center gap-2
`.trim();

export const emptyState = `
  flex flex-col items-center justify-center p-8 text-center text-slate-400
`.trim();

export const modalBackdrop = `
  fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-md
  animate-in fade-in duration-200
`.trim();

export const modalCard = `
  w-full max-w-md bg-slate-900 border border-slate-700/80 rounded-2xl shadow-2xl p-6
  flex flex-col gap-4 relative animate-in zoom-in-95 duration-200
`.trim();
